import React from 'react';

let logout = ({ width, height }: SVGProps) => (
  <svg
    id="prefix__Component_4_1"
    width={width}
    height={height}
    data-name="Component 4 \u2013 1"
    viewBox="0 0 24 24"
  >
    <defs>
      <style>{'.prefix__cls-1{fill:#1a1a1a}'}</style>
    </defs>
    <g
      id="prefix__Group_15"
      data-name="Group 15"
      transform="translate(-590 -379)"
      opacity={0.6}
    >
      <g id="prefix__left-arrow" transform="translate(592 381)">
        <g id="prefix__Group_16" data-name="Group 16">
          <path
            id="prefix__Path_48"
            d="M10 20A10 10 0 100 10a10.012 10.012 0 0010 10zm0-19a9 9 0 11-9 9 9.011 9.011 0 019-9z"
            className="prefix__cls-1"
            data-name="Path 48"
          />
          <path
            id="prefix__Path_49"
            d="M129.453 170.476a.5.5 0 00.71-.706l-1.958-1.958h7.48a.5.5 0 000-1H128.2l1.958-1.958a.5.5 0 10-.706-.706l-2.81 2.81a.5.5 0 000 .706z"
            className="prefix__cls-1"
            data-name="Path 49"
            transform="translate(-121.341 -157.312)"
          />
        </g>
      </g>
    </g>
  </svg>
);

let pieOverview = ({ width, height, fill }: SVGProps) => (
  <svg
    id="prefix__Component_2_1"
    width={width}
    height={height}
    data-name="Component 2 \u2013 1"
    viewBox="0 0 24 24"
  >
    <defs>
      <style>{`.prefix__cls-2{fill:${fill}}`}</style>
    </defs>
    <g id="prefix__pie-chart" transform="translate(1.95 2)">
      <g id="prefix__Group_2" data-name="Group 2" transform="translate(.05)">
        <path
          id="prefix__Path_12"
          d="M17.341 59.46h-7.8v-7.793a.565.565 0 00-.567-.567 8.927 8.927 0 108.929 8.927.57.57 0 00-.562-.567zm-8.362 8.36a7.793 7.793 0 01-.567-15.566v7.772a.565.565 0 00.567.567h7.774a7.8 7.8 0 01-7.774 7.228z"
          className="prefix__cls-2"
          data-name="Path 12"
          transform="translate(-.05 -48.954)"
        />
        <path
          id="prefix__Path_13"
          d="M259.644 8.9a8.926 8.926 0 00-8.927-8.9.565.565 0 00-.567.567v8.36a.565.565 0 00.567.567h8.36a.565.565 0 00.567-.567zm-8.36-.533V1.159a7.8 7.8 0 017.206 7.206h-7.206z"
          className="prefix__cls-2"
          data-name="Path 13"
          transform="translate(-239.644)"
        />
      </g>
    </g>
  </svg>
);

let bill = ({ width, height, fill }: SVGProps) => (
  <svg
    id="prefix__Component_3_1"
    width={width}
    height={height}
    data-name="Component 3 \u2013 1"
    viewBox="0 0 24 24"
  >
    <defs>
      <style>{`.prefix__cls-3{fill:${fill}}`}</style>
    </defs>
    <g
      id="prefix__Group_5"
      data-name="Group 5"
      transform="translate(-401 -233)"
    >
      <g id="prefix__invoice" transform="translate(395.65 235)">
        <g id="prefix__Group_4" data-name="Group 4" transform="translate(7.35)">
          <path
            id="prefix__Path_14"
            d="M26.211 0H7.862a.512.512 0 000 1.024h1.105v18.451a.514.514 0 00.269.452.505.505 0 00.525-.026l2.223-1.481 2.232 1.485a.509.509 0 00.568 0l2.223-1.481 2.232 1.485a.509.509 0 00.568 0l2.223-1.481 2.232 1.485a.519.519 0 00.282.085.553.553 0 00.243-.06.514.514 0 00.269-.452l-.01-18.449h1.165a.514.514 0 00.512-.512.525.525 0 00-.512-.525zm-2.177 18.519l-1.72-1.144a.509.509 0 00-.568 0l-2.223 1.485-2.232-1.485a.509.509 0 00-.568 0L14.5 18.856l-2.23-1.48a.509.509 0 00-.568 0l-1.711 1.139V1.02H24.03z"
            className="prefix__cls-3"
            data-name="Path 14"
            transform="translate(-7.35)"
          />
          <path
            id="prefix__Path_15"
            d="M112.962 168.624h5.364a.512.512 0 000-1.024h-5.364a.512.512 0 100 1.024z"
            className="prefix__cls-3"
            data-name="Path 15"
            transform="translate(-107.965 -161.448)"
          />
          <path
            id="prefix__Path_17"
            d="M301.462 168.624h1.34a.512.512 0 100-1.024h-1.34a.512.512 0 100 1.024z"
            className="prefix__cls-3"
            data-name="Path 17"
            transform="translate(-288.422 -161.448)"
          />
          <path
            id="prefix__Path_19"
            d="M112.962 72.324h5.364a.512.512 0 000-1.024h-5.364a.512.512 0 100 1.024z"
            className="prefix__cls-3"
            data-name="Path 19"
            transform="translate(-107.965 -68.258)"
          />
          <path
            id="prefix__Path_21"
            d="M301.462 72.324h1.34a.512.512 0 100-1.024h-1.34a.512.512 0 100 1.024z"
            className="prefix__cls-3"
            data-name="Path 21"
            transform="translate(-288.422 -68.258)"
          />
          <path
            id="prefix__Path_23"
            d="M112.962 266.124h5.364a.512.512 0 000-1.024h-5.364a.512.512 0 100 1.024z"
            className="prefix__cls-3"
            data-name="Path 23"
            transform="translate(-107.965 -255.788)"
          />
          <path
            id="prefix__Path_25"
            d="M301.462 266.124h1.34a.512.512 0 100-1.024h-1.34a.512.512 0 100 1.024z"
            className="prefix__cls-3"
            data-name="Path 25"
            transform="translate(-288.422 -255.788)"
          />
        </g>
      </g>
    </g>
  </svg>
);

let projectList = ({ width, height, fill }: SVGProps) => (
  <svg
    id="prefix__Component_5_1"
    width={width}
    height={height}
    data-name="Component 5 \u2013 1"
    viewBox="0 0 24 24"
  >
    <defs>
      <style>{`.prefix__cls-4{fill:${fill}}`}</style>
    </defs>
    <g id="prefix__list" transform="translate(2 1.7)">
      <g id="prefix__Group_29" data-name="Group 29" transform="translate(0 .3)">
        <path
          id="prefix__Path_58"
          d="M4.539.3H1.41A1.311 1.311 0 00.1 1.61v3.129a1.311 1.311 0 001.31 1.31h3.129a1.311 1.311 0 001.31-1.31V1.61A1.311 1.311 0 004.539.3zm.31 4.439a.31.31 0 01-.31.31H1.41a.31.31 0 01-.31-.31V1.61a.31.31 0 01.31-.31h3.129a.31.31 0 01.31.31v3.129z"
          className="prefix__cls-4"
          data-name="Path 58"
          transform="translate(-.096 -.3)"
        />
        <path
          id="prefix__Path_59"
          d="M0 179.139a1.311 1.311 0 001.31 1.31h3.129a1.311 1.311 0 001.31-1.31v-3.129a1.311 1.311 0 00-1.31-1.31H1.314A1.311 1.311 0 000 176.01v3.129zm1-3.133a.31.31 0 01.31-.31h3.129a.31.31 0 01.31.31v3.129a.31.31 0 01-.31.31H1.314a.31.31 0 01-.31-.31v-3.129z"
          className="prefix__cls-4"
          data-name="Path 59"
          transform="translate(0 -167.585)"
        />
        <path
          id="prefix__Path_60"
          d="M0 353.439a1.311 1.311 0 001.31 1.31h3.129a1.311 1.311 0 001.31-1.31v-3.129a1.311 1.311 0 00-1.31-1.31H1.314A1.311 1.311 0 000 350.31v3.129zm1-3.129a.31.31 0 01.31-.31h3.129a.31.31 0 01.31.31v3.129a.31.31 0 01-.31.31H1.314a.31.31 0 01-.31-.31v-3.129z"
          className="prefix__cls-4"
          data-name="Path 60"
          transform="translate(0 -334.773)"
        />
        <path
          id="prefix__Path_61"
          d="M190.6 59.4h11.24a.5.5 0 000-1H190.6a.5.5 0 100 1z"
          className="prefix__cls-4"
          data-name="Path 61"
          transform="translate(-182.344 -56.03)"
        />
        <path
          id="prefix__Path_62"
          d="M190.6 233.8h11.24a.5.5 0 000-1H190.6a.5.5 0 100 1z"
          className="prefix__cls-4"
          data-name="Path 62"
          transform="translate(-182.344 -223.314)"
        />
        <path
          id="prefix__Path_63"
          d="M190.6 408.1h11.24a.5.5 0 000-1H190.6a.5.5 0 100 1z"
          className="prefix__cls-4"
          data-name="Path 63"
          transform="translate(-182.344 -390.503)"
        />
      </g>
    </g>
  </svg>
);

let chevronUpCircleOutline = ({ fill }: SVGProps) => (
  <svg
    id="prefix__Component_7_5"
    width={24}
    height={24}
    data-name="Component 7 \u2013 5"
    viewBox="0 0 24 24"
  >
    <defs>
      <style>{`.prefix__cls-5{fill:${fill}}`}</style>
    </defs>
    <g
      id="prefix__Group_30"
      data-name="Group 30"
      transform="rotate(90 496.5 -93.5)"
    >
      <g id="prefix__left-arrow" transform="translate(592 381)">
        <g id="prefix__Group_16" data-name="Group 16">
          <path
            id="prefix__Path_48"
            d="M10 20A10 10 0 100 10a10.012 10.012 0 0010 10zm0-19a9 9 0 11-9 9 9.011 9.011 0 019-9z"
            className="prefix__cls-5"
            data-name="Path 48"
          />
          <path
            id="prefix__Path_49"
            d="M129.453 170.476a.5.5 0 00.71-.706s-2.523-2.371-2.513-2.494.556-.466 2.513-2.424a.5.5 0 10-.706-.706l-2.81 2.81a.5.5 0 000 .706z"
            className="prefix__cls-5"
            data-name="Path 49"
            transform="translate(-118.341 -157.312)"
          />
        </g>
      </g>
    </g>
  </svg>
);

let loginBackground = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Component_21_3"
    width="1440"
    height="900"
    data-name="Component 21 – 3"
    viewBox="0 0 1440 900"
  >
    <defs>
      <style>{`.cls-1{fill:url(#linear-gradient)}.cls-2{fill:#fff;opacity:.04}`}</style>
      <linearGradient
        id="linear-gradient"
        x2="1"
        y2="1"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stop-color="#7276f7" />
        <stop offset="1" stop-color="#5458e1" />
      </linearGradient>
    </defs>
    <path
      id="Rectangle_95"
      d="M0 0h1440v900H0z"
      className="cls-1"
      data-name="Rectangle 95"
    />
    <path
      id="Path_57"
      d="M0 0h1440v400s-147.729-54.189-348.966-46.2c-222.569 8.839-444.009 107.28-716.767 105.218S0 345.557 0 345.557z"
      className="cls-2"
      data-name="Path 57"
    />
  </svg>
);

let megaphone = ({ width, height, fill }: SVGProps) => (
  <svg width={width} height={height} viewBox="-4 -6 24 24">
    <defs>
      <style>{`.prefix__cls-1{fill:${fill}}`}</style>
    </defs>
    <g id="prefix__megaphone" transform="translate(0 -61.206)">
      <g
        id="prefix__Group_11"
        data-name="Group 11"
        transform="translate(0 61.206)"
      >
        <path
          id="prefix__Path_42"
          d="M14.663 65.31V61.7a.491.491 0 00-.269-.441.5.5 0 00-.519.033c-3.585 2.479-5.643 2.8-7.036 2.8H2.858A2.861 2.861 0 000 66.951v1.062a2.861 2.861 0 002.858 2.858h1.911L6.844 75.9a.5.5 0 00.461.31.533.533 0 00.192-.037.5.5 0 00.274-.653l-1.92-4.649h.984c4.851 0 6.835 2.568 6.925 2.687a.5.5 0 00.4.2.494.494 0 00.155-.024.5.5 0 00.343-.474v-3.6a2.234 2.234 0 000-4.353zM1 68.013v-1.062a1.859 1.859 0 011.858-1.858h1.748v4.777H2.858A1.859 1.859 0 011 68.013zm12.662 4.047a10.483 10.483 0 00-6.827-2.189H5.6v-4.778h1.235c1.429 0 3.479-.294 6.827-2.45zm1-3.45v-2.25a1.231 1.231 0 010 2.25z"
          className="prefix__cls-1"
          data-name="Path 42"
          transform="translate(0 -61.206)"
        />
        <path
          id="prefix__Path_43"
          d="M419.758 202.693H417.8a.5.5 0 000 1h1.956a.5.5 0 100-1z"
          className="prefix__cls-1"
          data-name="Path 43"
          transform="translate(-400.26 -196.916)"
        />
        <path
          id="prefix__Path_44"
          d="M411.821 143.451a.5.5 0 00.466.318.581.581 0 00.184-.033l1.895-.743a.5.5 0 00-.368-.931l-1.895.743a.5.5 0 00-.282.646z"
          className="prefix__cls-1"
          data-name="Path 44"
          transform="translate(-394.973 -138.727)"
        />
        <path
          id="prefix__Path_45"
          d="M414.313 245.806l-1.895-.743a.5.5 0 00-.368.931l1.895.743a.486.486 0 00.184.033.5.5 0 00.465-.318.5.5 0 00-.281-.646z"
          className="prefix__cls-1"
          data-name="Path 45"
          transform="translate(-394.922 -237.521)"
        />
      </g>
    </g>
  </svg>
);

let download = ({ width, height }: SVGProps) => (
  <svg width={width} height={height} viewBox="0 -4 24 24">
    <defs>
      <style>{'.prefix__cls-7{fill:#5458e1}'}</style>
    </defs>
    <g
      id="prefix__download_1_"
      data-name="download (1)"
      transform="translate(0 -17.25)"
    >
      <g
        id="prefix__Group_41"
        data-name="Group 41"
        transform="translate(0 17.25)"
      >
        <path
          id="prefix__Path_102"
          d="M19.427 228.235a.571.571 0 00-.573.573v5.212a2.571 2.571 0 01-2.568 2.568H3.714a2.571 2.571 0 01-2.568-2.568v-5.3a.573.573 0 10-1.146 0v5.3a3.718 3.718 0 003.714 3.714h12.572A3.718 3.718 0 0020 234.02v-5.212a.573.573 0 00-.573-.573z"
          className="prefix__cls-7"
          data-name="Path 102"
          transform="translate(0 -219.198)"
        />
        <path
          id="prefix__Path_103"
          d="M140.04 31.236a.577.577 0 00.4.17.559.559 0 00.4-.17l3.642-3.642a.573.573 0 10-.811-.811l-2.661 2.666V17.823a.573.573 0 00-1.146 0v11.626l-2.664-2.666a.573.573 0 00-.811.811z"
          className="prefix__cls-7"
          data-name="Path 103"
          transform="translate(-130.443 -17.25)"
        />
      </g>
    </g>
  </svg>
);

let exportIcon = ({ width, height }: SVGProps) => (
  <svg width={width} height={height} viewBox="0 0 20 18.536">
    <defs>
      <style>{'.prefix__cls-8{fill:#5458e1}'}</style>
    </defs>
    <g
      id="prefix__download_1_"
      data-name="download (1)"
      transform="translate(0 -17.25)"
    >
      <g
        id="prefix__Group_41"
        data-name="Group 41"
        transform="translate(0 17.25)"
      >
        <path
          id="prefix__Path_102"
          d="M19.427 228.235a.571.571 0 00-.573.573v5.212a2.571 2.571 0 01-2.568 2.568H3.714a2.571 2.571 0 01-2.568-2.568v-5.3a.573.573 0 10-1.146 0v5.3a3.718 3.718 0 003.714 3.714h12.572A3.718 3.718 0 0020 234.02v-5.212a.573.573 0 00-.573-.573z"
          className="prefix__cls-8"
          data-name="Path 102"
          transform="translate(0 -219.198)"
        />
        <path
          id="prefix__Path_103"
          d="M140.04 17.42a.577.577 0 01.4-.17.559.559 0 01.4.17l3.642 3.642a.573.573 0 01-.811.811l-2.661-2.666v11.625a.573.573 0 11-1.146 0V19.207l-2.664 2.665a.573.573 0 11-.811-.811z"
          className="prefix__cls-8"
          data-name="Path 103"
          transform="translate(-130.443 -17.25)"
        />
      </g>
    </g>
  </svg>
);

const SVG = {
  logout,
  pieOverview,
  bill,
  projectList,
  chevronUpCircleOutline,
  loginBackground,
  megaphone,
  download,
  exportIcon,
};

export default SVG;
